'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	adjacentToolTip: {
		marginLeft: '15px'
	},
	toolTip: {
		fontSize: '20px',
		pointerEvents: 'auto',
		verticalAlign: 'sub'
	}
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMSelectField/styles/index.js